import { Base2Presenter } from "core/presenter";
import { SaleRepository } from "core/repository";

export default class ViewSaleButtonPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      document: {
        visible: false,
        blob: null,
        name: null
      }
    };
  }

  async onRequestSaleDocument() {
    const { sale } = this.props;

    let type;

    if (sale.document.type === "order") type = "ordem";
    else if (sale.document.type === "receipt") type = "recibo";
    else if (sale.document.type === "cfe") type = "cfe";
    else type = "nfce";

    this.enqueue({ loading: true });

    const saleDocumentResult = await SaleRepository.getDocument(sale.uuid);
    if (saleDocumentResult.success) {
      this.enqueue(vm => ({
        document: {
          ...vm.document,
          visible: true,
          blob: saleDocumentResult.data,
          name: `${type}-${sale.document.number}`
        }
      }));
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Não conseguimos carregar o documento desta venda. Tente novamente mais tarde."
      });
    }

    this.enqueue({ loading: false });
  }

  onHideDocument() {
    this.enqueue(vm => ({
      document: {
        visible: false,
        blob: null
      }
    }));
  }
}



// WEBPACK FOOTER //
// ./src/components/support/view-sale-button/presenter.js